import PrintLabel from 'app/modules/labels/views/PrintLabel';
import useTitle from 'app/ui-components/Title/useTitle';

const PrintLabelPage = () => {
  useTitle('Print Label');
  return <PrintLabel />;
};

export default PrintLabelPage;
